<template>
  <div class="body">
    <div class="popup">
      <div class="t-c">用户登录</div>
      <van-field v-model="iccid" name="mobile" label="" placeholder="请输入你要激活的号码"
        :rules="[{ required: true, message: '请输入你要激活的号码' }]" />
      <van-button class="bu_tn" round block type="info" native-type="submit" @click="userQuerySIM">立即登录</van-button>
      <van-button class="bu_tn1" round block type="info" native-type="submit" @click="noStop" >激活视频</van-button>
    </div>
    <div class="zxkf" style=""  @click="noStop" >
      <img src="@/assets/kf.png" style="width:26px;height: 26px;margin-top:4px;">
      <div class="zxkf-btn" >在线客服</div>
    </div>
  </div>
</template>


<script>
import { Dialog } from "vant";
import { Toast } from "vant";
import { wxRequest } from "@/api/user.js";
import SeAutocomplete from "@/components/SeAutocomplete";
import Advertisement from "@/components/Advertisement";
export default {
  components: { SeAutocomplete, Advertisement },
  data() {
    return {
      loginLog: [], //历史记录的卡号
      phoneList: [], //手机绑定的卡号
      isOpenid: 0,
      iccid: "",
      code: "",
      showAds: true,
      gzh: "",
      homeTitle: '',
      realNameList: [
        "1192351241053663232",
        "1224969664338063360",
        "1255666672321163264",
        "7DA692EC992B45E297450F40DEDC5614",
        "8601954A2B074E80AACAAF32C5EE232C",
        "960F3276EFAA4ED2999754895F4BCCB4",
        "B1E112B9F1D8420E9072D9F47D6A135E",
        "1275705014286807040",
        "1275706083402313728",
        "1274979554988912640",
        "1279289937396494336",
      ],
      suolangList: ["1275704520822747136"],

      isDialogShow: false,
      dialogIccid: '',
      inx: null,

      loginImg: '',
      loginUrl: '',
      isShowImg: false

    };
  },
  methods: {
    noStop(){
      Dialog.alert({ title: "温馨提示", message: "演示暂不支持此功能" });
    },
    toUrl() {
      if (this.loginUrl) {
        window.location.href = this.loginUrl;
      }
    },
    selectIon(item, index) {
      this.inx = index
      this.iccid = item.cardNo
    },



    querySearch(queryString, cb) {
      var listAll = this.getAutoCompleteData("iccidList");
      var results = queryString
        ? listAll.filter(this.createFilter(queryString))
        : listAll;
      cb(results);
    },
    createFilter(queryString) {
      return (listAll) => {
        return listAll.indexOf(queryString) == 0;
      };
    },
    handleSelect(item) {
      this.iccid = item;
    },
    userQuerySIM() {
      if (!this.iccid || this.iccid.length < 3) {
        Dialog.alert({ title: "提示", message: "请输入正确卡号" });
        return false;
      }

      let recordLoginText = this.iccid; //存放用户登录时输入的文本，将用于首页显示

      let data = {
        requestId: this.iccid,
        code: this.code,
        isOpenid: this.isOpenid
      };
      wxRequest("sim/bind", data, "get").then((res) => {
        if (res.data.code == 200) {
          let record = res.data.data;
          let iccid = record.iccid;
          if (record.titleMap) {
            localStorage.setItem("wxTitle", record.titleMap.title);
            localStorage.setItem("wxText", record.titleMap.context);
            localStorage.setItem("wxUrls", record.titleMap.urls);
          } else {
            localStorage.setItem("wxTitle", '');
            localStorage.setItem("wxText", '');
            localStorage.setItem("wxUrls", '');
          }

          localStorage.setItem('newHomeImg', record.newHomeImg);
          localStorage.setItem('newHomeImg2', record.newHomeImg2);
          localStorage.setItem('newHomeUrl', record.newHomeUrl);
          localStorage.setItem('isNewPage', record.isNewPage);
          this.$store.state.isNewPage = record.isNewPage;

          localStorage.setItem("isBindPhone", record.isBindPhone);

          localStorage.setItem("mobile", record.mobile);
          localStorage.setItem("supplierTypeName", record.supplierTypeName);
          localStorage.setItem("wxHeadImg", record.wxHeadImg);
          localStorage.setItem("wxNickName", record.wxNickName);
          localStorage.setItem("recordLoginText", recordLoginText);
          localStorage.setItem("supplierName", record.supplierName);
          localStorage.setItem("iccid", iccid);
          localStorage.setItem("intoNo", record.intoNo);
          localStorage.setItem("phoneNo", record.userPhone);
          localStorage.setItem("userPhone", record.userPhone);

          localStorage.setItem("openId", record.openId);
          localStorage.setItem("agentId", record.agentId);
          localStorage.setItem("flowRatePool", record.flowRatePool);
          this.$store.state.recordLoginText = recordLoginText;
          this.$store.state.supplierCode = res.data.data.supplierCode;
          this.$store.state.iccid = iccid;
          this.$store.state.flowRatePool = res.data.data.flowRatePool;

          this.$store.state.intoNo = record.intoNo;
          this.setAutoCompleteData("iccidList", recordLoginText, 10);
          //未实名的电信卡用户（通过cardType字段判断），实名认证时将只需要绑定
          let cardType = record.supplierCode;
          if (this.realNameList.indexOf(cardType) > -1) {
            //暂不做处理
          }
          if (record.isToYuCun != 1) {
            this.$router.replace("/user/openPrice");
          }else {
            let _data = { iccid: record.iccid };
            wxRequest("bindPhone/state", _data, "post").then((res) => {
              if (res.data.code == 200) {
                let result = res.data.data;
                localStorage.setItem(
                  "applyChangeSimState",
                  result.applyChangeSimState
                );
                if (result.bindState == 2) {
                  this.$router.push({
                    path: "/userNew/bindPhone",
                    query: {
                      iccid: record.iccid,
                    },
                  });
                } else {
                  if (record.isNewPage == 0) {
                    this.$router.replace('/user/home');
                  } else if (record.isNewPage == 1) {
                    this.$router.replace('/userNew/home');
                  } else if (record.isNewPage == 2) {
                    this.$router.replace('/user/homeNew');
                  } else if (record.isNewPage == 3) {
                    this.$router.replace('/new/home');
                  }
                }
              } else {
                Dialog.alert({ title: "提示", message: res.data.message });
              }
            });
          }
        } else if (res.data.code == 666) { //此时要弹出手机绑定列表，让用户来选择登录的卡号。 用户选择完卡号之后  继续请求 userQuerySIM 方法
          this.phoneList = res.data.data; // cardNo 表示展示的卡号。 poolName 表示类型
          this.isDialogShow = true
        } else {
          Dialog.alert({ title: "提示", message: res.data.message });
        }
      });
    },

    //获取url参数
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },

    goBuyCard() {
      window.location.href = "http://test01.sekj.vip/#/user/login2";
    },

    // goto(path){
    //     //广告点击统计
    //     wxRequest("link/click",{url: path}, "get").then(res => {
    //         window.location.href = path;
    //     });

    // },
  },
  async created() {
    var source = this.getQueryVariable("source") ? this.getQueryVariable("source") : process.env.VUE_APP_APPID;
    this.dialogIccid = ''
    var appid = source ? source : process.env.VUE_APP_APPID;
    await wxRequest("sim/get/login/remark", {}, "post").then((res) => {
      this.homeTitle = res.data.data.loginRemark;
      if (res.data.data.loginImg && res.data.data.loginImg.length > 5) {
        this.loginImg = "http://test01.sekj.vip:8888/" + res.data.data.loginImg;
        this.loginUrl = res.data.data.loginUrl;
        this.isShowImg = true;
      }
    })


    if (this.$route.query.iccid) {
      this.iccid = this.$route.query.iccid;
    }

    await wxRequest("/sim/get/appId", {}, "get").then((res) => {
      if (res.data.code == 200) {
        appid = res.data.data;
      }
    });
    localStorage.setItem("appid", appid);
    localStorage.setItem("isHeadquarterAppid", true);

    //先查询是否是乐刷支付 如果是乐刷支付 就不用授权了
    await wxRequest("sim/get/pay/state", { iccid: localStorage.getItem("iccid") }, "post").then((res) => {
      if (res.data.code == 200) {
        localStorage.setItem("leshuaPay", 1);
        this.code = "leshua";
      } else {
        localStorage.setItem("leshuaPay", 2);
        var redirectUrl = window.location.href;
        var index = redirectUrl.indexOf("code");
        redirectUrl = encodeURIComponent(redirectUrl);
        if (index < 0) {
           window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_base#wechat_redirect`;
        } else {
          var search = window.location.search;
          console.log("search", search);
          var startIndex = search.indexOf("code");
          var endIndex = search.indexOf("&", startIndex);
          var str = search.slice(startIndex, endIndex);
          var code = str.slice(str.indexOf("=") + 1);
          this.code = code;
          if (this.$route.query.iccid) {
            this.iccid = this.$route.query.iccid;
          } else {
            this.iccid = localStorage.getItem("recordLoginText");
          }
        }
      }
    });

    this.$store.commit("setIsHeadquarterAppid", "true");
    localStorage.setItem("isHeadquarterAppid", true);


    if (this.$route.query.iccid) {
      this.iccid = this.$route.query.iccid;
      this.userQuerySIM();
    }
  },

  mounted() { },

  beforeDestory() { },
};
</script>



<style lang="less" scoped>
.more-dialog {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 10001;

  .more-bg {
    background: rgba(0, 0, 0, .3);
    width: 100%;
    height: 100%;
  }

  .more-list {
    width: 90%;
    height: 400px;
    background: #fff;
    border-radius: 10px;
    position: absolute;
    top: 0;
    left: 0;
    margin: auto;
    bottom: 0;
    right: 0;

    .more-title {
      text-align: center;
      font-size: 19px;
      border-radius: 14px;
      font-weight: 600;
      color: #222222;
      height: 51px;
      padding-top: 22px;
      background: linear-gradient(180deg, #DAE8FF 0%, rgba(255, 255, 255, 0) 100%);
    }

    .more-list-flex {
      overflow: auto;
      height: 220px;
    }

    .more-list-item {
      display: flex;
      height: 60px;
      width: 85%;
      margin: 0 auto 8px;
      border: 1px solid #EEF4FF;
      align-items: center;

      img {
        width: 65px;
        height: 18px;
        margin-left: 10px;
        margin-right: 20px;
      }

      .num {
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #94959A;
        line-height: 20px;
      }
    }

    .active {
      border: 1px solid #1772FF;
    }

    .dialog-btn {
      display: flex;
      position: absolute;
      bottom: 18px;
      width: 100%;
      height: 40px;
      justify-content: space-around;

      .close {
        width: 121px;
        height: 44px;
        background: #F5F5F5;
        border-radius: 7px;
        font-size: 15px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        text-align: center;
        line-height: 44px;
      }

      .corm {
        width: 121px;
        height: 44px;
        background: linear-gradient(90deg, #50A9FF 0%, #1772FF 100%);
        border-radius: 7px;
        font-size: 15px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #fff;
        text-align: center;
        line-height: 44px;
      }
    }
  }

}

.body {
  .more-dialog {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 10001;

    .more-bg {
      background: rgba(0, 0, 0, .3);
      width: 100%;
      height: 100%;
    }

    .more-list {
      width: 90%;
      height: 400px;
      background: #fff;
      border-radius: 10px;
      position: absolute;
      top: 0;
      left: 0;
      margin: auto;
      bottom: 0;
      right: 0;

      .more-title {
        text-align: center;
        font-size: 19px;
        border-radius: 14px;
        font-weight: 600;
        color: #222222;
        height: 51px;
        padding-top: 22px;
        background: linear-gradient(180deg, #DAE8FF 0%, rgba(255, 255, 255, 0) 100%);
      }

      .more-list-flex {
        overflow: auto;
        height: 220px;
      }

      .more-list-item {
        display: flex;
        height: 60px;
        width: 85%;
        margin: 0 auto 8px;
        border: 1px solid #EEF4FF;
        align-items: center;

        img {
          width: 65px;
          height: 18px;
          margin-left: 10px;
          margin-right: 20px;
        }

        .num {
          height: 20px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #94959A;
          line-height: 20px;
        }
      }

      .active {
        border: 1px solid #1772FF;
      }

      .dialog-btn {
        display: flex;
        position: absolute;
        bottom: 18px;
        width: 100%;
        height: 40px;
        justify-content: space-around;

        .close {
          width: 121px;
          height: 44px;
          background: #F5F5F5;
          border-radius: 7px;
          font-size: 15px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          text-align: center;
          line-height: 44px;
        }

        .corm {
          width: 121px;
          height: 44px;
          background: linear-gradient(90deg, #50A9FF 0%, #1772FF 100%);
          border-radius: 7px;
          font-size: 15px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #fff;
          text-align: center;
          line-height: 44px;
        }
      }
    }

  }

  background:#fff url("../../assets/lgbj.png") no-repeat;
  background-size: 100%;
  width: 100%;
  height: 100%;
  position: relative;

  .popup {
    .t-c {
      text-align: center;
      padding-top: 300px;
      font-size: 24px;
      font-weight: bold;
    }

    .van-cell {
      height: 50px;
      width: 60%;
      border-radius: 30px;
      border: 1px solid #ddd;
      padding-left: 10px;
      padding: 0;
      background: none;
      margin: auto;
      text-align: center;
      margin-top: 20px;
      line-height: 48px;

      ::v-deep .van-cell__title {
        width: 0;
      }

      ::v-deep .van-cell__value {
        line-height: 48px;

        .van-field__body {
          .van-field__control {
            line-height: 48px;
            height: 48px;
            text-align: center;
          }
        }
      }
    }

    .bu_tn {
      height: 50px;
      line-height: 50px;
      text-align: center;
      width: 60%;
      color: #fff;
      background: #f7691a;
      border-radius: 30px;
      margin: auto;
      margin-top: 20px;
      border: 1px solid #f7691a;
    }

    .bu_tn1 {
      height: 32px;
      line-height: 32px;
      text-align: center;
      width: 30%;
      color: #f7691a;
      background: #fff;
      border-radius: 30px;
      margin: auto;
      margin-top: 20px;
      border: 1px solid #f7691a;
    }
  }

  .zxkf {
    width: 30px;
    height: 100px;
    position: fixed;
    border-radius: 25px;
    right: 6px;
    bottom: 180px;
    text-align: center;
    background: #FF9866;

    .zxkf-btn {
      font-size: 14px;
      color: #fff;
      line-height: 15px;
      margin: 0 8px;
      margin-top: -2px;
    }
  }
}
</style>